var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterColored = function SvgTwitterColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.104 2.102a8.284 8.284 0 0 1-2.265.588A3.773 3.773 0 0 0 19.576.638c-.76.422-1.6.732-2.505.898A4.047 4.047 0 0 0 14.198.358c-2.545 0-4.41 2.242-3.842 4.566-3.273-.158-6.178-1.637-8.123-3.886-1.032 1.667-.536 3.856 1.216 4.966a4.183 4.183 0 0 1-1.784-.468c-.04 1.72 1.264 3.328 3.161 3.69a4.12 4.12 0 0 1-1.777.06c.505 1.48 1.953 2.551 3.682 2.582-1.657 1.23-3.746 1.773-5.835 1.54a11.636 11.636 0 0 0 6.043 1.667c7.315 0 11.452-5.826 11.204-11.056a7.793 7.793 0 0 0 1.96-1.917Z",
    fill: "#5D5BEA"
  })));
};
export default SvgTwitterColored;